<template>
  <BaseDialog
    :is-open="isOpen"
    @close="$emit('close')"
    type="basic"
    :title="$t('dialog.coachRetract.title')"
  >
    <p class="text-body-large">
      {{ $t('dialog.coachRetract.description') }}
    </p>
    <template #confirm>
      <BaseTextButton color="filled" size="M" :disabled="disabled" @click="$emit('coachRetractDialog')">{{
        $t('dialog.coachRetract.action')
      }}</BaseTextButton>
    </template>
    <template #dismiss>
      <BaseTextButton @click="$emit('close')" size="M">{{ $t('common.cancel') }}</BaseTextButton>
    </template>
  </BaseDialog>
</template>

<script setup lang="ts">
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'

  interface Props {
    isOpen: boolean
    disabled?: boolean
  }

  defineProps<Props>()

  defineEmits<{
    (e: 'close'): void
    (e: 'coachRetractDialog'): void
  }>()
</script>
